export default {
  GET_ALL_FILE_SERVERS: 'getAllFileServers',
  SAVE_FILE_SERVER: 'saveFileServer',
}
